import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddSchoolUserComponent } from '../add-school-user/add-school-user.component';
import { SchoolService } from '../school.service';
import { DtoSchool, DtoSchoolUser } from '../../../models/school.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CommentDialogComponent } from '../../../shared/components/comment-dialog/comment-dialog.component';
import { Router } from '@angular/router';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { DocumentType, MatDialogCloseEvent } from '../../../const';
import { EditSchoolComponent } from '../../user-center/edit-school/edit-school.component';
import { PageEvent } from '@angular/material/paginator';
import { Role, RolePayload } from '../../../models/role.model';
import { AccountAdminCenterService } from '../../account-admin-center/account-admin-center.service';
import { ConfirmDialogComponent } from '../../mat-account/confirm-dialog/confirm-dialog.component';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { RoleMaster } from '../../user-center/user-role/user-role.component';
import { timer } from 'rxjs';
import { UserRoles } from '../../../models/mat-account.model';
import { Users } from '../../../models/user-center.model';
import { SharedService } from '../../../shared/services/shared.service';

export enum ActionType { EditSchoolUser = "edit", DeleteSchoolUser = "delete" }

@Component({
  selector: 'app-school-details',
  templateUrl: './school-details.component.html',
})

export class SchoolDetailsComponent implements OnInit, OnChanges {
  @Output() resetCreateTrigger = new EventEmitter<void>();
  @Output() showSchoolUserList = new EventEmitter<string>();
  @Output() hideCreateButton = new EventEmitter<boolean>();
  @Output() paginationData = new EventEmitter<any>();
  @Output() hideHeaderOnCreateSchool = new EventEmitter<boolean>();
  @Input() isCurrentTab: string = "";
  @Input() assignedPackageId: number = 0;
  @Input() clientAccountId: number = 0;
  @Input() independentSchoolData: DtoSchool[] = [];
  @Input() goBack: number = 2;
  @Input() createTriggered: boolean = false;
  @Input() totalRecords: number = 0;
  @Input() searchTriggered: boolean = false;
  @Input() searchTerm: string = "";
  @Input() openedFromIndependentSchool: boolean = false;

  pageSize:number = 10;
  pageNumber:number = 0;
  pageOffSet:number = 0;
  sortSchoolNameAsc: boolean = true;
  sortAddressAsc: boolean = true;
  sortLocationAsc: boolean = true;
  sortSchoolTypeAsc: boolean = true;
  sortCurriculumAsc: boolean = true;
  sortLocalAuthorityAsc: boolean = true;
  sortAssignedAccountAdminAsc: boolean = true;
  router: any;
  roleName: string[] = [];
  schoolData: DtoSchool[] = [];
  schoolUsers: DtoSchoolUser[] = [];
  filteredSchoolUsers: DtoSchoolUser[] = [];
  showSchoolUser: boolean = false;
  showCreateUser: boolean = false;
  roles: Role[] = [];
  schoolId: number = 0;
  roleMaster = RoleMaster;
  userRole: string[] = [];
  userEmail: string = "";
  sortColumn: string = "";
  sortDirection: string = "";
  accountAdminList: Users[] = [];
  schoolAdminExists: boolean = false;

  constructor(public dialog: MatDialog, private schoolService: SchoolService,
              public toasterService: ToastrService, private route: Router,
              private accountAdminCenterService: AccountAdminCenterService,
              private matAccountService: MatAccountService, private sharedService: SharedService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if(changes['createTriggered']?.currentValue){
      if(this.showSchoolUser){
        this.getRoles(this.clientAccountId);
        this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
          this.schoolUsers = response;
          this.filteredSchoolUsers = [...this.schoolUsers];
  
          this.schoolAdminExists = this.schoolUsers?.some(user =>
            user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
          );
          this.openCreateSchoolUserDialog();
        },(err: HttpErrorResponse)=>{
          if(err.error){
            this.toasterService.error(err.error, "Error");
          }
        })
      }
      else{
        this.showCreateUser = true;
      }
      return;
    }
    if(changes['independentSchoolData']?.currentValue){
      this.schoolData = this.independentSchoolData;
      return;
    }
    if(changes['searchTriggered']?.currentValue){
      if(this.showSchoolUser){
        this.filterUsers();
        this.resetCreateTrigger.emit();
      }
      return;
    }
    else{
      this.filterUsers();
    }
    
    if(changes['goBack']?.currentValue == 0) {
      this.hideCreateButton.emit(true);
    }
    if(changes['goBack']?.currentValue == 1){
      this.showSchoolUser = false;
      this.schoolUsers = [];
      this.filteredSchoolUsers = [];
      this.schoolId = 0;
      this.hideCreateButton.emit(false);
    }
  }

  filterUsers() {
    if(!this.searchTerm){
      this.filteredSchoolUsers = [...this.schoolUsers];
      this.schoolAdminExists = this.schoolUsers?.some(user =>
        user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
      );
    }
    else{
      this.filteredSchoolUsers = this.schoolUsers.filter(user =>
        user.firstName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.lastName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.emailId?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.countryCode?.toString().toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
  }

  getGridData(sortColumn = "", sortDirection = ""){
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.pageIndex = this.pageNumber;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
      if(this.clientAccountId == 0){ //Independent School
        this.paginationData.emit(payload);
      }
      else{
        this.getSchoolDetails(this.clientAccountId, payload);
      }
  }
  
  hideHeader(value: boolean){
    this.hideHeaderOnCreateSchool.emit(value);
    this.showCreateUser = false;
    this.showSchoolUser = false;
    this.schoolUsers = [];
    this.filteredSchoolUsers = [];
    this.schoolId = 0;
    this.resetCreateTrigger.emit();
    
    if(this.clientAccountId > 0){
      this.getSchoolDetails(this.clientAccountId);
    }
    if(this.independentSchoolData.length){
      this.schoolData = this.independentSchoolData;
    }
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.paginationData.emit(event);
  }
  
  ngOnInit(): void {
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    if(this.clientAccountId > 0){
      this.getSchoolDetails(this.clientAccountId);
    }
    if(this.independentSchoolData.length){
      this.schoolData = this.independentSchoolData;
    }
    this.getRoles(this.clientAccountId);
    this.getAccountAdminDetails();
  }

  getAccountAdminDetails() {
    let payload: UserRoles = {} as UserRoles;
    payload.userRole = this.userRole;
    this.matAccountService.getAccountAdminDetails(this.userRole).subscribe((response: Users[] | any) => {
      this.accountAdminList = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }
  
  goToMyInsights(school: DtoSchool){
    if(school.clientAccountId==0)
      sessionStorage.removeItem('client_account');
    else
      sessionStorage.setItem('client_account', school.clientAccountId.toString());
    
    sessionStorage.setItem('client_reference', school.clientReference!.toString());
    sessionStorage.setItem('package_of_client_account', school.assignedPackageId!.toString());
    sessionStorage.setItem('my_ref_school_id', school.myReferenceSchoolCode.toString());
    sessionStorage.setItem('school_id', school.schoolId!.toString());
    
    this.sharedService.loadReportForSelectedIndividualSchoolCheck(true);
  }

  getRoles(clientAccountId: number){
    let payload = {
      isIndividualEntity : clientAccountId == 0,
      clientAccountId : clientAccountId > 0 ? [clientAccountId] : this.schoolData.map(x=>x.schoolId)
    } as RolePayload;
    this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>{
    //this.schoolService.getRoles(clientAccountId).subscribe((response: Role[] | any)=>{
      this.roles = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
  
  getSchoolDetails(clientAccountId: number, payload: any = {}){
    this.schoolService.getSchools(clientAccountId, payload).subscribe((data: DtoSchool[] | any)=>{
      this.schoolData = data;
      this.searchTriggered = false;
    }, (error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  openCommentModal(comment: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '500px',
      data: comment
    });
  }

  editSchool(school: DtoSchool){
    this.dialog.open(EditSchoolComponent,{
      width: '1000px',
      data: { school: school, isEdit: true, accountAdminList: this.accountAdminList }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        if(this.clientAccountId > 0){
          this.getSchoolDetails(this.clientAccountId);
        }
        if(this.openedFromIndependentSchool){
          this.getGridData();
        }
      }
    })
  }

  deleteSchool(school: DtoSchool){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the school?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.schoolService.deleteSchool(school.schoolId!).subscribe((response: any)=>{
          if (response) {
            this.toasterService.success('School deleted successfully', 'Success');
            if(this.clientAccountId > 0){
              this.getSchoolDetails(this.clientAccountId);
            }
            if(this.openedFromIndependentSchool){
              this.getGridData();
            }
          }
        }, (errorResponse: HttpErrorResponse) => {
          if(errorResponse.error){
            this.toasterService.error(errorResponse.error, "Error");
          }
        })
      }
    });
  }

  goToSchoolUsers(school: DtoSchool){
    this.schoolId = school.schoolId!;
    this.schoolUsers = this.schoolData.filter(schoolUser => schoolUser.schoolId == school.schoolId)[0].schoolUsers;
    this.filteredSchoolUsers = this.schoolUsers && this.schoolUsers.length ? [...this.schoolUsers] : [];

    this.schoolAdminExists = this.schoolUsers?.some(user =>
      user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
    );

    this.hideCreateButton.emit(true);
    if(this.openedFromIndependentSchool){
      this.route.navigate(['/adminDetails'], { queryParams: { clientAccountId: this.clientAccountId, clientAccountName: "", packageId: school.assignedPackageId, independentSchoolData: 1, schoolId: school.schoolId, schoolName: school.schoolName, numberOfUsersToAllow: school.numberOfSchoolUser } });
    }
    this.showSchoolUser = true;
    this.showSchoolUserList.emit(school.schoolName!);
  }

  actionTriggered(value: any) {
    let action = value.action;
    let index = value.index;
    switch(action){
      case ActionType.EditSchoolUser:
        this.getRoles(this.clientAccountId);
        this.openCreateSchoolUserDialog(this.filteredSchoolUsers[index]);
        return;
      case ActionType.DeleteSchoolUser:
        this.openDeleteSchoolUser(index);
        return;
      default:
        return ""
    }
  }

  async openCreateSchoolUserDialog(userDetail: DtoSchoolUser = {} as DtoSchoolUser): Promise<any>{
    //Opened upon Create School User from MAT Account
    try{
      let numberOfUsers = await this.matAccountService.allowCreateSchoolUser(this.schoolId);
      if (numberOfUsers) {
        userDetail.contactNumber = userDetail.phoneNumber;
        if(userDetail.role?.length && userDetail.role?.length == 1 && userDetail.role[0].roleName == "SchoolAdmin"){
          userDetail.isAdmin = true;
        }
        
        let roles = this.roles.filter(x=>x.isActive);
        //if(!this.schoolAdminExists)
        {
          if (!roles.some(r => r.roleId === Number(RoleMaster.SchoolAdmin)))
          {
            roles = [{
              roleId: Number(RoleMaster.SchoolAdmin),
              roleName: 'School Admin'
            } as Role, ...roles];
          }
        }

        this.dialog.open(AddSchoolUserComponent, {
          width: '1000px',
          data: {
            userDetail: userDetail.schoolUserId ? userDetail : {},
            assignedPackageId: this.assignedPackageId,
            roles: roles,
            schoolId: this.schoolId,
            clientAccountId: this.clientAccountId,
            allowBulkUpload: true,
            availableNumberOfSchoolUsersToCreate: numberOfUsers
          }
        }).afterClosed().subscribe((popupEvent: any)=>{
          if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
            if(userDetail.userId > 0){
              popupEvent.data.userDetails.userId = userDetail.userId;
              this.schoolService.updateSchoolUser(popupEvent.data.userDetails).subscribe((response: any)=>{
                if(response){
                  this.toasterService.success("School user details updated successfully","Success");
                  this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
                    this.schoolUsers = response;
                    this.filteredSchoolUsers = [...this.schoolUsers];

                    this.schoolAdminExists = this.schoolUsers?.some(user =>
                      user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
                    );
                  },(err: HttpErrorResponse)=>{
                    if(err.error){
                      this.toasterService.error(err.error, "Error");
                    }
                  })
                }
              },(err: HttpErrorResponse)=>{
                if(err.error){
                  this.toasterService.error(err.error, "Error");
                }
              });
            }
            else{
              if(popupEvent.data.isBulkUploaded){
                timer(1000).subscribe(() => {
                  this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
                    this.schoolUsers = response;
                    this.filteredSchoolUsers = [...this.schoolUsers];

                    this.schoolAdminExists = this.schoolUsers?.some(user =>
                      user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
                    );
                  },(err: HttpErrorResponse)=>{
                    if(err.error){
                      this.toasterService.error(err.error, "Error");
                    }
                  })
                });
                this.resetCreateTrigger.emit();
                return;
              }
              popupEvent.data.userDetails.schoolId = this.schoolId;
              this.schoolService.createSchoolUser([popupEvent.data.userDetails]).subscribe((response: any)=>{
                if(response.isSuccess){
                  this.toasterService.success("School user details created successfully", "Success");
                  this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
                    this.schoolUsers = response;
                    if (popupEvent.data.fileData && popupEvent.data.fileData.has('file')) {
                      const user = this.schoolUsers.find(user => user.emailId === popupEvent.data.userDetails.emailId);
                      if(user){
                        this.uploadDocument(popupEvent.data.fileData, DocumentType.EntityAudience, user.userId.toString());
                      }
                      setTimeout(()=>{
                        this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
                          this.schoolUsers = response;
                          this.filteredSchoolUsers = [...this.schoolUsers];

                          this.schoolAdminExists = this.schoolUsers?.some(user =>
                            user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
                          );
                        },(err: HttpErrorResponse)=>{
                          if(err.error){
                            this.toasterService.error(err.error, "Error");
                          }
                        })
                      }, 1000)
                    }
                    this.filteredSchoolUsers = [...this.schoolUsers];

                    this.schoolAdminExists = this.schoolUsers?.some(user =>
                      user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
                    );
                  },(err: HttpErrorResponse)=>{
                    if(err.error){
                      this.toasterService.error(err.error, "Error");
                    }
                  })
                }
              },(err: HttpErrorResponse)=>{
                if(err.error){
                  this.toasterService.error(err.error, "Error");
                }
              })
            }
          }
          this.getRoles(this.clientAccountId);
          this.resetCreateTrigger.emit();
        });
      }
      this.resetCreateTrigger.emit();
    }
    catch (errorResponse: any) {
      this.toasterService.error(errorResponse.error, 'Error');
      this.resetCreateTrigger.emit();
      return false;
    }
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }

  openDeleteSchoolUser(userIndex: number){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the school user?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        let schoolUser = this.filteredSchoolUsers[userIndex];
        if(schoolUser.userId > 0){
          this.dialog.open(ConfirmComponent, {
            width: '375px',
            data: {
              status: true,
              message: "Are you sure want to delete the school User?"
            }
          }).afterClosed().subscribe((popupEvent: any)=>{
            if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
              this.accountAdminCenterService.deleteUser(schoolUser.userId.toString()).subscribe((response: any)=>{
                if (response) {
                  this.toasterService.success('User details deleted successfully', 'Success');
                  this.schoolService.getSchoolUsers(this.userEmail ,this.schoolId).subscribe((response: DtoSchoolUser[] | any)=>{
                    this.schoolUsers = response;
                    this.filteredSchoolUsers = [...this.schoolUsers];

                    this.schoolAdminExists = this.schoolUsers?.some(user =>
                      user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
                    );
                  },(err: HttpErrorResponse)=>{
                    this.toasterService.error(err.error, "Error");
                  })
                }
              }, (errorResponse: HttpErrorResponse) => {
                if(errorResponse.error){
                  this.toasterService.error(errorResponse.error, "Error");
                }
              })
            }
          });
        }
      }
    });
  }

  ViewDocument(data: DtoSchool){
    if(!data.document.length){
      this.toasterService.warning("No attachment found");
      return;
    }
    this.dialog.open(ConfirmDialogComponent, {
      width: '675px',
      data: {
        hideUpload: true,
        files: data.document // Pass files to the dialog
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.doc){
        data.document = popupEvent.doc;
      }
    });
  }

}
